/* eslint-disable no-lonely-if */
import AppTheme from '../Enums/AppTheme';

export function getTableRowBackgroundColor(index: number, isOpen: boolean, isSelected: boolean, theme: AppTheme): string {

    const isEven: boolean = index % 2 === 0;

    if (theme === AppTheme.LIGHT_MODE) {
        if (isEven && isOpen && isSelected) {
            return '#61DBED';
        } else if (isEven && isOpen && !isSelected) {
            return '#50CADC';
        } else if (isEven && !isOpen && isSelected) {
            return '#D4D4D4';
        } else if (isEven && !isOpen && !isSelected) {
            return '#E5E5E5';
        } else if (!isEven && isOpen && isSelected) {
            return '#61DBED';
        } else if (!isEven && isOpen && !isSelected) {
            return '#50CADC';
        } else if (!isEven && !isOpen && isSelected) {
            return '#EEEEEE';
        } else {
            return '#FFFFFF';
        }
    } else { //dark mode
        if (isEven && isOpen && isSelected) {
            return '#118B9D';
        } else if (isEven && isOpen && !isSelected) {
            return '#007A8C';
        } else if (isEven && !isOpen && isSelected) {
            return '#3B3F43';
        } else if (isEven && !isOpen && !isSelected) {
            return '#2A2E32';
        } else if (!isEven && isOpen && isSelected) {
            return '#118B9D';
        } else if (!isEven && isOpen && !isSelected) {
            return '#007A8C';
        } else if (!isEven && !isOpen && isSelected) {
            return '#2E3135';
        } else {
            return '#1D2024';
        }
    }
}